module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDEwMCAxMjUiIHg9IjBweCIgeT0iMHB4Ij48dGl0bGU+OTRhbGw8L3RpdGxlPjxwYXRoIGQ9Ik01MCw1LjE0Yy0xNy44MywwLTMyLjc1LDE0LjMtMzQsMzIuNTZBMzUuMjcsMzUuMjcsMCwwLDAsMjMuMjMsNjFMNDcuNiw5My42NmEzLDMsMCwwLDAsNC44MSwwTDc2Ljc3LDYxQTM1LjI3LDM1LjI3LDAsMCwwLDg0LDM3LjdDODIuNzUsMTkuNDQsNjcuODMsNS4xNCw1MCw1LjE0Wm0wLDQ3LjExYTE0LjUsMTQuNSwwLDEsMSwxNC40My0xNC41QTE0LjQ4LDE0LjQ4LDAsMCwxLDUwLDUyLjI1WiIgZmlsbD0iI0ZGRkZGRiIgLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/pin-white.svg
// module id = 492
// module chunks = 35783957827783